import { render, staticRenderFns } from "./cooperationProperty.vue?vue&type=template&id=47723d99"
import script from "./cooperationProperty.vue?vue&type=script&lang=js"
export * from "./cooperationProperty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports